import React from 'react'
import { IconProps } from './Icon.types'
import iconSet from './selection.json'
import IcomoonReact from 'icomoon-react'
import colors from '../../constants/colors'
import { colorIndex } from '../../constants/colors/colors.types'
import styled from 'styled-components'

const StyledIcomoonReact = styled(IcomoonReact)<IconProps>`
  cursor: ${(props) => props.cursor};
`

const Icon: React.FC<IconProps> = ({ size = '24px', className, name, color = '', ...props }) => {
  return (
    <StyledIcomoonReact
      className={className}
      iconSet={iconSet}
      color={colors[color as colorIndex] || color}
      size={size}
      icon={name}
      {...props}
    />
  )
}

export default Icon
